import React from 'react' // eslint-disable-line no-unused-vars
import connect from 'react-redux/es/connect/connect'
import { addNotification as notify } from 'reapop'
import AdminNavigation from './AdminNavigation'
import TagGroup from '../../forms/TagGroup'
import { validateField } from '../../pages/functions'
import { api } from '../index.api'

class AdminManageAdGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      fields: {
        adGroup: { name: 'adGroup', value: '', rules: { title: '' } }
      }
    }
  }

    componentDidMount = () => {
      api.admin.adGroup.getAdGroupMappigForSearch(
        this._getADGroupSuccessHandler.bind(this),
        this._getADGroupErrorHandler.bind(this)
      )
    }

    _getADGroupSuccessHandler = roleAdGroup => {
      const { fields } = this.state
      const searchAdGroups = roleAdGroup.adGroups.join(';')
      this.searchRoleId = roleAdGroup.id
      this.searchRoleName = roleAdGroup.role
      fields.adGroup.value = searchAdGroups
      this.lastSavedGroups = searchAdGroups
      this.setState({ fields })
    }

    _getADGroupErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be some error while retrieving AD Groups associated with Document Search.' +
            'Please retry again.', 'error')
    }

    _validate = (e, field) => {
      const fields = validateField(e, field, this.state.fields)
      this.setState({ fields })

      return false
    }

    handleSaveClick = e => {
      const roleAdGroup = {
        id: this.searchRoleId,
        role: this.searchRoleName,
        adGroups: this.state.fields.adGroup.value.split(';')
      }

      api.admin.adGroup.updateSearchAdGroups(
        roleAdGroup,
        this._updateAdGroupSuccessHandler.bind(this),
        this._updateAdGroupErrorHandler.bind(this)
      )
    }

    _updateAdGroupSuccessHandler = response => {
      if (response.status === 200) {
        this.lastSavedGroups = this.state.fields.adGroup.value
        this._showNotification('Success', 'AD Groups updated successfully.', 'success')
      } else if (response.status === 401) {
        this._showNotification('Error', 'You are not authorized to perform this action. Please log in again.', 'error')
        const { fields } = this.state
        fields.adGroup.value = this.lastSavedGroups
        this.setState({ fields })
        setTimeout(() => window.location.replace('/'), 3000)
      } else {
        this._showNotification('Error', 'There seems to be some error while updating AD Groups.', 'error')
        const { fields } = this.state
        fields.adGroup.value = this.lastSavedGroups
        this.setState({ fields })
      }
    }

    _updateAdGroupErrorHandler = (error) => { /* eslint-disable-line */
      this._showNotification('Error', 'There seems to be an error at our server side. Please try later.', 'error')
      const { fields } = this.state
      fields.adGroup.value = this.lastSavedGroups
      this.setState({ fields })
    }

    _showNotification = (title, message, status) => {
      const { notify } = this.props
      notify({
        title,
        message,
        status,
        position: 'tr',
        dismissible: true,
        dismissAfter: 6000
      })
    }

    render () {
      const languageContent = this.props.pageContent.content
      return (
        <div className='v2_container'>
          <div className='row'>
            <AdminNavigation className='col-xl-2 col-lg-3 col-md-4 col-6' />
            <div className='col-xl-10 col-lg-9 col-md-8 col-6 p-l-15'>
              <div className='row'>
                <div className='col-12 col-xl-12'>
                  <h3 className='mb-3 header-primary'>{languageContent.module.admin.adGroup.heading}</h3>
                  <p>{languageContent.module.admin.adGroup.addAdGroup}</p>
                </div>
              </div>
              <div className='row  mb-4'>
                <div id='admin-ad-group' className='col-md-10'>
                  <TagGroup
                    field={this.state.fields.adGroup}
                    validate={(e, field) => this._validate(e, this.state.fields.adGroup)}
                    ref={cd => { this.tagGroupField = cd }}
                    overrideLayout
                    removeKeys={[]}
                    onlyUnique
                    placeholder='Start Typing Group Name'
                  />
                </div>
              </div>
              <div className='col-md-2'>
                <button
                  onClick={this.handleSaveClick}
                  className='btn btn-info btn-lg-wide submit-button btn-icon btn-rounded'
                >
                  <span>{languageContent.module.admin.adGroup.save}</span>
                </button>
              </div>

            </div>
          </div>

        </div>
      )
    }
}

function mapStateToProps (state) {
  return {
    referenceData: state.referenceData,
    pageContent: state.pageContent
  }
}

export default connect(mapStateToProps, { notify })(AdminManageAdGroup)



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AdminManageAdGroup.js